import icon_shifts from "./icon_shifts.svg"
import icon_collapse from "./icon_collapse.svg"

export const ShiftsIcons = {
    icon_shifts,
    icon_collapse
}